import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

const MainContainer: React.FC = ({ children }) => {
  return (
    <React.Fragment>
      <CssBaseline />
      <Container
        maxWidth="lg"
        sx={{
          opacity: 1,
          ml: 0,
          mr: 0,
          maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          maxHeight: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
        }}
      >
        {children}
      </Container>
    </React.Fragment>
  );
};

export default MainContainer;
